import { useEffect, useState } from 'react'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSpecificitiesOfProduct } from "src/common/razzle-platform-specificityofproduct/effects"
import { SPECIFICITIES_OF_PRODUCT_PROPS_ID } from "src/common/razzle-platform-specificityofproduct/ssr"
import { IParamsOption, IRequestFetcherOptions } from 'src/common/razzle-platform-components/types'


type UseSpecificitiesOfProduct<T> = {
    specificitiesOfProduct: Array<T>,
    inProgress: boolean
}

// we use ths function to get the specificities of product on the client side
export function useSpecificitiesOfProduct<T>(options: Pick<IParamsOption, 'params'>  = {}):  UseSpecificitiesOfProduct<T> {
    const dispatch = useDispatch()
    const locale: string = useSelector((state: any) => state.translationModel.locale)
    // get the initial state of specificitiesOfProductProps by it sheared id
    const initialProps = useSelector((state: any) => state.ssrModel[SPECIFICITIES_OF_PRODUCT_PROPS_ID]) || {}
    const [inProgress, setInProgress] = useState(false)
    // we use this state to save our specificities
    const [state, setState] = useState({ specificitiesOfProduct: initialProps.specificitiesOfProduct })

    useEffect(() => {

        if (initialProps.specificitiesOfProduct) {
            // case when we make reload or refresh on the browser we get the saved specificities form the server (window.__PRELOADED_STATE__)

            // we remove all initialProps of specificitiesOfProductProps
            dispatch.ssrModel.cleanInitialProps(SPECIFICITIES_OF_PRODUCT_PROPS_ID)
        } else {

            // in specificity of product we need params for make forced request exmaple: parms: { _embed: [user, ...etc]}
            const queryOptions: Pick<IRequestFetcherOptions, 'params'> = {
                params: options.params,
            }

            // case when we are on browser (pass from page to another) we don't need to get specificities form the server side
            const fetchData = async () => {
                setInProgress(true)

                // set the Accept-Language to the headers of the request for get the translated data
		        const headers = { "Accept-Language": locale }

                // get the specificities of product by execute the effect fetchSpecificitiesOfProduct and pass it queryOptions
                const {specificitiesOfProduct} = await fetchSpecificitiesOfProduct(queryOptions, headers)
                // save the specificities in our state
                setState({ specificitiesOfProduct })
                setInProgress(false)
            }
            fetchData()
        }

	}, [])

    return { specificitiesOfProduct: state.specificitiesOfProduct, inProgress }
}
